export const UnitLabelTestPageObject = (
    onChangeLabel: (nextLabel: string) => void,
    edit: boolean,
    editableValue: string,
    getValue: () => string
) => ({
    getType: () => "UnitLabel",

    setValue: (value: string) => onChangeLabel(value),

    getValue: () => (edit ? editableValue : getValue()),
});
